import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from 'foundations-library/components'
import PDCMarkdown from 'pdc-markdown'

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignSelf: 'stretch'
    },
    transcription: {
        display: 'flex',
        padding: '20px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '29px',
        alignSelf: 'stretch'
    }
}))

/**
 *
 */
export default function CallTranscript ({ transcription }: { transcription?: string }): JSX.Element {
    const classes = useStyles()

    return (
        <div className={classes.root}>
            <div className={classes.transcription}>
                <Typography variant='body2'>
                    <PDCMarkdown>
                        {transcription || ''}
                    </PDCMarkdown>
                </Typography>
            </div>
        </div>
    )
}
